import styled from 'styled-components/native';

import { Text } from 'app/components/Common/Styled';

export const Label = styled(Text).attrs({
  size: 'small',
})`
  margin-top: ${({ theme }) => theme.spacing / -2}px;
`;
